import { render } from "./RatingStar.vue?vue&type=template&id=0dda7cc6"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/RatingStar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0dda7cc6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0dda7cc6', __exports__)) {
    api.reload('0dda7cc6', __exports__)
  }
  
  module.hot.accept("./RatingStar.vue?vue&type=template&id=0dda7cc6", () => {
    api.rerender('0dda7cc6', render)
  })

}


export default __exports__